import React from 'react'
import Image from 'next/image'
import {motion} from 'framer-motion'

import {t} from '@lib/helpers'
import {logEvent} from '@lib/gtm'

export const Hero = ({animationProps, scrollTo}) => {
  return (
    <section className='DataLabeling__hero'>
      <div className='DataLabeling__hero__container'>
        <img
          className='DataLabeling__hero__container__circle'
          alt='Data Labeling'
          src='/images/services/data-labeling/circle-bg.svg'
        />
        <div className='DataLabeling__hero__container__img'>
          <motion.div {...animationProps(0.1)}>
            <img
              className='DataLabeling__hero__container__img__circle'
              alt='Data Labeling'
              src='/images/services/data-labeling/circle-bg.svg'
              style={{position: 'absolute'}}
            />
            <Image
              alt='Data Labeling'
              src='/images/services/data-labeling/hero.png'
              width='440px'
              height='532px'
              priority
            />
          </motion.div>
        </div>
        <div className='DataLabeling__hero__container__content'>
          <div className='DataLabeling__hero__container__content--desktop'>
            <div
              className='title'
              dangerouslySetInnerHTML={{
                __html: t('pages.dataLabeling.hero.title'),
              }}
            />
          </div>
          <div className='DataLabeling__hero__container__content--mobile'>
            <div
              className='title'
              dangerouslySetInnerHTML={{
                __html: t('pages.dataLabeling.hero.titleMobile'),
              }}
            />
          </div>
          <motion.a
            {...animationProps(0.2)}
            href='#contact'
            onClick={(e) => {
              scrollTo(e)
              logEvent({
                ga: {
                  category: 'Data Labeling',
                  action: 'Action: Click CTA',
                },
              })
            }}
            className='DataLabeling__hero__container__content__button'
          >
            {t('pages.dataLabeling.hero.button')}
          </motion.a>
        </div>
      </div>
    </section>
  )
}
